import React from "react";

// Helpers
import cloneDeep from "lodash.clonedeep";
import { ScrollDisable } from "../../helpers/ScrollLock";

// Custom components
import ComparisonPhotoDropzone from "../ComparisonPhotoDropzone/ComparisonPhotoDropzone";
import ComparisonPhotoProcessing from "../ComparisonPhotoProcessing/ComparisonPhotoProcessing";
import { SquareXButton, TextUtilityButton } from "../Buttons/Buttons";

function ComparisonCard(props) {
  const {
    entryType,
    calculationProgress,
    imageProcessingStatuses,
    // setImageProcessingStatuses,
    index,
    setCurrentComparisonIndex,
    baseComparisonItem,
    comparisonItems,
    comparisonItem,
    setComparisonItems,
    setCurrentMenu,
    setModalImage,
    compareModalOpen,
    setCompareModalOpen,
    entryBrowserModalOpen,
    setEntryBrowserModalOpen,
    comparisonItemLocation,
    setComparisonItemLocation,
    rapidEntry,
  } = props;

  const handlePairComparison = () => {
    setCurrentComparisonIndex(index);
    setCurrentMenu("split");
    setCompareModalOpen(!compareModalOpen);

    ScrollDisable();
  };

  const resetRegularPair = () => {
    const dataCopy = [...comparisonItems];
    dataCopy.splice(index, 1);
    setComparisonItems(dataCopy);
  };

  const resetComputedPair = () => {
    const dataCopy = [...comparisonItems];
    dataCopy[index] = cloneDeep(baseComparisonItem);
    setComparisonItems(dataCopy);
  };

  // Check if images are missing in the pair, or a calculation must be completed.
  const isPairNotAtIndex =
    comparisonItems[index].fileOne.length === 0 ||
    comparisonItems[index].fileTwo.length === 0;

  const isWaitingForCalculation =
    calculationProgress?.state === "NOT STARTED" ||
    calculationProgress?.state === "PENDING" ||
    calculationProgress?.state === "PROGRESS" ||
    calculationProgress?.state === "FAILURE";

  return (
    <div className="flex flex-col items-center justify-center w-full h-full Xbg-red-500">
      {/* Top right X to clear image pair. */}
      {((entryType === "compute" &&
        imageProcessingStatuses[index] === "processed") ||
        (entryType === "compare" && comparisonItems.length > 1)) && (
        <div className="flex flex-row items-center w-full justify-end pb-2">
          <SquareXButton
            actionFunction={
              entryType === "compute" ? resetComputedPair : resetRegularPair
            }
          />
        </div>
      )}

      {entryType === "compute" ? (
        <ComparisonPhotoProcessing
          index={index}
          comparisonItem={comparisonItem}
          setComparisonItems={setComparisonItems}
          comparisonItems={comparisonItems}
          setModalImage={setModalImage}
          imageProcessingStatuses={imageProcessingStatuses}
          calculationProgress={calculationProgress}
          entryBrowserModalOpen={entryBrowserModalOpen}
          setEntryBrowserModalOpen={setEntryBrowserModalOpen}
          comparisonItemLocation={comparisonItemLocation}
          setComparisonItemLocation={setComparisonItemLocation}
          rapidEntry={rapidEntry}
        />
      ) : (
        <ComparisonPhotoDropzone
          index={index}
          comparisonItem={comparisonItem}
          setComparisonItems={setComparisonItems}
          comparisonItems={comparisonItems}
          setModalImage={setModalImage}
          entryBrowserModalOpen={entryBrowserModalOpen}
          setEntryBrowserModalOpen={setEntryBrowserModalOpen}
          comparisonItemLocation={comparisonItemLocation}
          setComparisonItemLocation={setComparisonItemLocation}
          rapidEntry={rapidEntry}
        />
      )}

      <div className="flex flex-row items-center w-full justify-end pt-2">
        <TextUtilityButton
          prompt={"Compare"}
          actionFunction={handlePairComparison}
          disabled={isWaitingForCalculation || isPairNotAtIndex}
        />
      </div>

      <div className="w-full py-4">
        <div className="w-full h-[1px] bg-neutral-300" />
      </div>
    </div>
  );
}

export default ComparisonCard;
